<hydrao-global-loading-spinner></hydrao-global-loading-spinner>
<!-- <hydrao-admin-bar></hydrao-admin-bar> -->
@if (appStore.loading$()) {
<mat-progress-bar
  class="top-loading-spinner"
  mode="query"
  color="primary"
></mat-progress-bar>
} @if (!userStore.loading$()) { @if (appStore.mobileMode$()) {
<div
  class="menu-toggle-button"
  [class.adminBehalf]="authStore.adminBehalf || appStore.adminMode$()"
>
  <button mat-icon-button (click)="mainMenu.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
</div>
<div class="overlay" [class.opened]="appStore.overlayOpened$()"></div>
}
<joyrideStep
  joyrideStep="firstStep"
  stepPosition="center"
  [title]="dashboardStore.getTourTitle('firstStep')"
  [text]="dashboardStore.getTourText('firstStep')"
>
</joyrideStep>

<mat-sidenav-container autosize>
  <mat-sidenav
    mode="side"
    opened
    class="side-menu"
    [mode]="appStore.sideNavMode$()"
    [class.adminBehalf]="authStore.adminBehalf || appStore.adminMode$()"
    [opened]="appStore.mainMenuOpened$()"
    (openedChange)="mainMenuOpenedChanged($event)"
    #mainMenu
  >
    <div
      class="menu-wrapper"
      joyrideStep="menu"
      [title]="dashboardStore.getTourTitle('menu')"
      [text]="dashboardStore.getTourText('menu')"
    >
      <a
        routerLink="/dashboard"
        joyrideStep="menuHome"
        [title]="dashboardStore.getTourTitle('menuHome')"
        [text]="dashboardStore.getTourText('menuHome')"
      >
        @if (!appStore.mobileMode$()) {
        <div>
          @if (!appStore.sideMenuReduced$()) {
          <div class="hydrao-logo">
            <img src="assets/logo-hydrao.svg" />
          </div>
          } @else {
          <div class="hydrao-logo-small">
            <span inlineSVG="assets/drop.svg" class="drop"></span>
            <span class="dot">.</span>
          </div>
          }
        </div>
        } @else {
        <div class="menubutton-spacer"></div>
        }
      </a>
      <div
        class="menu-items"
        joyrideStep="continueTour"
        [title]="dashboardStore.getTourTitle('continueTour')"
        [text]="dashboardStore.getTourText('continueTour')"
      >
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'dashboard'"
          icon="home"
          i18n-label
          label="dashboard"
          [reduced]="appStore.sideMenuReduced$()"
          routerLink="/dashboard"
          queryParamsHandling="merge"
        >
        </hydrao-nav-button>
        @if (userStore.canViewAlerts$()) {
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'alerts'"
          icon="notifications_active"
          i18n-label
          [reduced]="appStore.sideMenuReduced$()"
          label="alerts"
          routerLink="/alerts"
          queryParamsHandling="merge"
        >
        </hydrao-nav-button>
        } @if (userStore.canViewPlaces$()) {
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'places'"
          icon="location_city"
          i18n-label
          [reduced]="appStore.sideMenuReduced$()"
          label="places"
          routerLink="/places"
          queryParamsHandling="merge"
        >
        </hydrao-nav-button>
        } @if (userStore.canViewSh$()) {
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'showerheads'"
          svgicon="shower_head"
          i18n-label
          label="showerheads"
          routerLink="/showerheads"
          queryParamsHandling="merge"
          [reduced]="appStore.sideMenuReduced$()"
        ></hydrao-nav-button>
        @if (activeTab() === "showerheads") {
        <ul
          class="sub-menu-items"
          [class.reduced]="appStore.sideMenuReduced$()"
        >
          @for (subMenu of showerheadsStore.headers$(); track subMenu.id) {
          <li
            class="sub-menu-item"
            [class.selected]="subMenu.id === subActiveTab()"
            (click)="onSubItemClicked(subMenu)"
          >
            {{ subMenu.label }}
          </li>
          }
        </ul>
        } } @if (userStore.canViewMeters$()) {
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'meters'"
          svgicon="meter"
          i18n-label
          label="menu_meters"
          routerLink="/meters"
          queryParamsHandling="merge"
          [reduced]="appStore.sideMenuReduced$()"
        >
        </hydrao-nav-button>
        @if (activeTab() === "meters") {
        <ul
          class="sub-menu-items"
          [class.reduced]="appStore.sideMenuReduced$()"
        >
          @for (subMenu of metersStore.headers$(); track subMenu.id) {
          <li
            class="sub-menu-item"
            [class.selected]="subMenu.id === subActiveTab()"
            (click)="onSubItemClicked(subMenu)"
          >
            {{ subMenu.label }}
          </li>
          }
        </ul>
        } } @if (userStore.canViewGateways$()) {
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'gateways'"
          icon="podcasts"
          i18n-label
          [reduced]="appStore.sideMenuReduced$()"
          label="gateways"
          routerLink="/gateways"
          queryParamsHandling="merge"
        >
        </hydrao-nav-button>
        } @if (userStore.canManageChildAccounts$()) {
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'accounts'"
          icon="supervisor_account"
          i18n-label
          label="users"
          routerLink="/accounts"
          queryParamsHandling="merge"
          [reduced]="appStore.sideMenuReduced$()"
        >
        </hydrao-nav-button>
        } @if (userStore.hasCustomPages$()) {
        <hydrao-nav-button
          title=""
          [selected]="activeTab() == 'custom'"
          icon="web"
          i18n-label
          label="custom pages"
          routerLink="/custom"
          queryParamsHandling="merge"
          [reduced]="appStore.sideMenuReduced$()"
        >
        </hydrao-nav-button>
        }
        <div
          joyrideStep="settingsStep"
          [title]="dashboardStore.getTourTitle('settingsStep')"
          [text]="dashboardStore.getTourText('settingsStep')"
        >
          <hydrao-nav-button
            [selected]="activeTab() == 'settings'"
            icon="account_circle"
            i18n-label
            label="account"
            routerLink="/settings"
            queryParamsHandling="merge"
            [reduced]="appStore.sideMenuReduced$()"
          >
          </hydrao-nav-button>
        </div>
      </div>

      <div
        class="account-wrapper"
        [class.reduced]="appStore.sideMenuReduced$()"
      >
        <div class="admin-panel">
          <!--prettier-ignore -->
          <span i18n>You're connected as administrator on another user account.</span>
        </div>
        <div class="account">{{ userStore.userEmail$() }}</div>
        <button
          mat-flat-button
          (click)="onLogoutClicked()"
          [disabled]="logoutLoading()"
        >
          <mat-icon>logout</mat-icon>
          <span i18n>logout</span>
        </button>
      </div>
      <div class="admin-icon" [class.reduced]="appStore.sideMenuReduced$()">
        <mat-icon>supervised_user_circle</mat-icon>
      </div>

      <div class="spacer"></div>

      <button
        class="button-on-menu reduce-button"
        [ngClass]="{ 'icon-only': appStore.sideMenuReduced$() }"
        (click)="toggleSideMenu()"
        mat-button
      >
        <mat-icon class="panel-open-icon">arrow_left</mat-icon>
        @if (!appStore.sideMenuReduced$()) {
        <span i18n>reduce</span>
        }
      </button>
    </div>
  </mat-sidenav>

  <mat-sidenav-content autosize>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
}
